import { Component, ViewChild, input, model, output, signal } from '@angular/core';

import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ModalComponent } from '../../../shared/components/modal/modal.component';
import { NgClass } from '@angular/common';
import { ToggleSwitch } from 'primeng/toggleswitch';
import { VaccineHistory } from './../../../shared/models/vaccine-history.model';
import { VaccineHistoryFormComponent } from './../../forms/vaccine-history-form/vaccine-history-form.component';
import { VaccineHistoryService } from '../../../services/vaccine-history/vaccine-history.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-vaccine-history-modal',
  imports: [
    ButtonModule,
    FormsModule,
    ToggleSwitch,
    ModalComponent,
    VaccineHistoryFormComponent,
    NgClass
  ],
  templateUrl: './vaccine-history-modal.component.html',
  styleUrl: './vaccine-history-modal.component.scss'
})
export class VaccineHistoryModalComponent {
  @ViewChild(VaccineHistoryFormComponent) vaccineHistoryForm!: VaccineHistoryFormComponent;

  readonly isDelete = input<boolean>(false);
  readonly vaccineHistory = input<VaccineHistory | null>(null);
  readonly petId = input.required<string>();
  readonly isOpen = model.required<boolean>();
  readonly success = output<VaccineHistory | null>();

  readonly isLoading = signal<boolean>(false);
  readonly isEnabled = signal<boolean>(true);

  constructor(private readonly vaccineHistoryService: VaccineHistoryService,
    private readonly messageService: MessageService
  ) {
  }

  onCloseModal(): void {
    if (this.isLoading()) {
      return;
    }

    this.isOpen.set(false);
  }

  createOrUpdateVaccineHistory(fields: any): void {
    const isUpdate = this.vaccineHistory() !== null;

    fields.petId = this.petId();

    let serviceAction;
    if (isUpdate) {
      fields.id = this.vaccineHistory()!.id;
      serviceAction = this.vaccineHistoryService.updateVaccineHistory(fields);
    } else {
      serviceAction = this.vaccineHistoryService.createVaccineHistory(fields);
    }

    serviceAction.subscribe({
      next: (vaccineHistory: VaccineHistory) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: `Registro de vacina ${isUpdate ? 'atualizado' : 'criado'} com sucesso!`,
          life: 4000
        });

        this.success.emit(vaccineHistory);
        this.isLoading.set(false);
        if (!isUpdate) {
          this.vaccineHistoryForm.resetForm();
        }
        this.onCloseModal();
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: `Falha ao ${isUpdate ? 'atualizar' : 'criar'} registro de vacina!`,
          life: 4000
        });
        this.isLoading.set(false);
      }
    });
  }

  deleteVaccineHistory(): void {
    this.isLoading.set(true);
    this.vaccineHistoryService.deleteVaccineHistory(this.vaccineHistory()!.id!)
      .pipe(finalize(() => this.isLoading.set(false)))
      .subscribe({
        next: () => {
          this.isLoading.set(false);
          this.messageService.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Registro de vacina deletado com sucesso!',
            life: 4000
          });
          this.success.emit(null);
          this.onCloseModal();
        },
        error: () => {
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail: 'Falha ao deletar registro de vacina!',
            life: 4000
          });
        }
      });
  }
}
